import type { KgFlowNodeType } from "../types";

/**
 * Semantic pipeline order for LR canvas layout (left → right).
 * Keep in sync with `elkConfig.TIER_PARTITION`.
 */
export const KG_TIER_PARTITION: Partial<Record<KgFlowNodeType, number>> = {
  dataSource: 0,
  schema: 1,
  table: 2,
  dataModel: 3,
  ontology: 4,
  metric: 5,
  report: 6,
  dataStory: 7,
  artifact: 8,
};

export const getKgNodeTier = (
  type: KgFlowNodeType | undefined,
): number | undefined =>
  type !== undefined ? KG_TIER_PARTITION[type] : undefined;
